// import { Table, Button, Form } from "react-bootstrap";
// import schoolApi from "../../api/schoolApi";
// import React, { useEffect, useState } from "react";
// import { toast } from "react-toastify";
// import { convertTo12HourFormat } from "../../utils/helper";

// export default function EditTimeTable({
//   timeTableSlots,
//   sessionId,
//   sectionId,
//   classId,
//   changeView,
//   category,
// }) {
//   console.log("Edit Loaded Data: ", timeTableSlots);
//   let periodIndex = 0;

//   let [teacherList, setTeacherList] = useState([]);
//   let [subjectList, setSubjectList] = useState([]);
//   let [timeTable, setTimeTable] = useState([]);
//   let [breakData,setBreakData] = useState({});
//   async function initTeacherList() {
//     try {
//       console.log("cateory==>", category);
//       teacherList = await schoolApi.getTeacherRecords(category);
//       console.log("teacherList", teacherList?.teacherData);
//       setTeacherList(teacherList?.teacherData);
//     } catch (error) {
//       toast.error(error.message);
//     }
//   }
//   async function initSubjectList() {
//     try {
//       subjectList = await schoolApi.fetchSubject();
//       if (subjectList.success) {
//         console.log("subjectList@!!@=>", subjectList);
//         setSubjectList(subjectList?.result);
//       }
//     } catch (error) {
//       toast.error(error.message);
//     }
//   }
//   useEffect(() => {
//     async function init() {
//       console.log("ushgdhsgjj", timeTableSlots);
//       if (timeTableSlots) {
//         setTimeTable(timeTableSlots);
//         timeTableSlots?.map((slot) => {
//           console.log("slotywtey=>", slot);
//           if (["break", "lunch"].includes(slot?.time_slot?.type?.toLowerCase())) {
//             setBreakData({
//               class_id: classId,
//               section_id: sectionId,
//               session_id: slot?.time_slot.session_id,
//               time_slot_id: slot?.time_slot.id
//           });
//           }
//         });
        
    
//       }
//       initTeacherList();
//       initSubjectList();
//     }
//     init();
//   }, []);

//   const onChangeTeacher = async (e, ttIndex, sIndex) => {
//     setTimeTable((prevTimetable) => {
//       const updatedTimetable = [...prevTimetable];
//       const timeTable = updatedTimetable[ttIndex];
//       const data = updatedTimetable[ttIndex].data[sIndex];
//       if (data.timetable) {
//         console.log("data.timetable --> ", data.timetable);
//         data.timetable.contact_id = e.target.value;
//       } else {
//         data.timetable = {
//           id: null,
//           contact_id: e.target.value,
//           subject_id: data.timetable ? data.timetable.subject_id : "",
//           time_slot_id: timeTable.time_slot.id,
//           section_id: sectionId,
//           class_id: classId,
//           session_id: sessionId,
//           day: data.day,
//         };
//       }
//       return updatedTimetable;
//     });
//   };

//   const onChangeSubject = async (e, ttIndex, sIndex) => {
//     setTimeTable((prevTimetable) => {
//       const updatedTimetable = [...prevTimetable];
//       const timeTable = updatedTimetable[ttIndex];
//       console.log("timeTable: ", timeTable);

//       const data = updatedTimetable[ttIndex].data[sIndex];
//       console.log("data: ", data);
//       if (data.timetable) {
//         console.log("data.timetable --> ", data.timetable);
//         data.timetable.subject_id = e.target.value;
//       } else {
//         data.timetable = {
//           id: null,
//           contact_id: data.timetable ? data.timetable.contact_id : "",
//           subject_id: e.target.value,
//           time_slot_id: timeTable.time_slot.id,
//           section_id: sectionId,
//           class_id: classId,
//           session_id: sessionId,
//           day: data.day,
//         };
//       }
//       return updatedTimetable;
//     });
//   };

//   const onSave = async () => {
//     try {
//       let timeTableRecords = [];
//       let isError = false;
//       for (const tt of timeTable) {
//         for (const data of tt.data) {
//           if (data.timetable) {
//             if (!data.timetable.subject_id || !data.timetable.contact_id) {
//               isError = true;
//               break;
//             }
//             timeTableRecords.push(data.timetable);
//           }
//         }
//         if (isError) {
//           break;
//         }
//       }
//       if (isError) {
//         toast.error("Required fields are missing, please select!", {
//           position: toast.POSITION.TOP_RIGHT,
//         });
//         return;
//       }
//       console.log('timeTableRecords@@@=>',timeTableRecords)
//       timeTableRecords.push(breakData);
//       let result = await schoolApi.upsertTimetable(timeTableRecords);
//       console.log(result);
//       if (result.success) {
//         toast.success("Record udpated successfully!", {
//           position: toast.POSITION.TOP_RIGHT,
//         });
//         changeView("VIEW");
//       } else {
//         let error = "Something went wrong!";
//         if (result.error) {
//           error = result.error;
//         }
//         toast.error(error, {
//           position: toast.POSITION.TOP_RIGHT,
//         });
//         console.log(error);
//       }
//     } catch (error) {
//       toast.error(error.message);
//     }
//   };

//   function TeacherOption({ teachRec, index, timeTableData, timeSlot }) {
//     let displayTeacher = !(teachRec.schedule && teachRec.schedule.length > 0);
//     if (!displayTeacher) {
//       let bookedSlots = teachRec.schedule.filter(
//         (record) =>
//           record.timeslot_id === timeSlot.time_slot.id &&
//           record.day === timeTableData.day
//       );
//       displayTeacher = bookedSlots.length === 0;
//       if (
//         !displayTeacher &&
//         timeTableData.timetable &&
//         timeTableData.timetable.id
//       ) {
//         bookedSlots = teachRec.schedule.filter(
//           (record) => record.id === timeTableData.timetable.id
//         );
//         displayTeacher = bookedSlots.length > 0;
//       }
//     }
//     return displayTeacher ? (
//       <option key={index} value={teachRec.id}>
//         {teachRec.teachername}
//       </option>
//     ) : (
//       <></>
//     );
//   }
//   return (
//     <Table striped bordered hover>
//       <thead>
//         <tr>
//           <th>Time Slot</th>
//           <th>Monday</th>
//           <th>Tuesday</th>
//           <th>Wednesday</th>
//           <th>Thursday</th>
//           <th>Friday</th>
//           <th>Saturday</th>
//         </tr>
//       </thead>

//       <tbody>
//         {timeTable && Object.keys(timeTable).length > 0
//           ? timeTable.map((timeSlot, ttIndex) => (
//               <React.Fragment key={ttIndex}>
//                 {console.log('timeSlot@@=>',timeSlot)}
//                 {timeSlot.time_slot.status === "active" && (
//                   <tr style={{ textAlign: "center" }}>
//                     <td style={{ paddingTop: "30px" }}>
//                       {convertTo12HourFormat(timeSlot.time_slot.start_time)} -{" "}
//                       {convertTo12HourFormat(timeSlot.time_slot.end_time)}
//                       <br /> <br />
//                       <p style={{ fontWeight: "bold" }}>
//                         {["Lunch", "lunch", "Break", "break"].includes(
//                           timeSlot.time_slot.type
//                         )
//                           ? ""
//                           : `(Period-${++periodIndex})`}{" "}
//                         {/* Increment only for periods */}
//                       </p>
//                     </td>
//                     {["Lunch", "lunch", "Break", "break"].includes(
//                       timeSlot.time_slot.type
//                     ) ? (
//                       <td
//                         colSpan={6}
//                         style={{
//                           textAlign: "center",
//                           fontWeight: "bold",
//                           paddingTop: "20px",
//                         }}
//                       >
//                         {timeSlot.time_slot.type.toLowerCase() === "lunch"
//                           ? "Lunch Time"
//                           : "Break Time"}
//                       </td>
//                     ) : (
//                       timeSlot.data.map((slotData, sIndex) => (
//                         <td key={sIndex}>
//                           <Form.Group className="mx-2">
//                             <Form.Select
//                               name="teacher"
//                               value={
//                                 slotData.timetable
//                                   ? slotData.timetable.contact_id
//                                   : ""
//                               }
//                               onChange={(e) =>
//                                 onChangeTeacher(e, ttIndex, sIndex)
//                               }
//                             >
//                               <option value="">-Select Teacher-</option>
//                               {teacherList?.map((teachRec, index) => (
//                                 <TeacherOption
//                                   teachRec={teachRec}
//                                   index={index}
//                                   timeTableData={slotData}
//                                   timeSlot={timeSlot}
//                                 />
//                               ))}
//                             </Form.Select>
//                           </Form.Group>

//                           <Form.Group className="mx-2 mt-3">
//                             <Form.Select
//                               name="subject"
//                               value={
//                                 slotData.timetable
//                                   ? slotData.timetable.subject_id
//                                   : ""
//                               }
//                               onChange={(e) =>
//                                 onChangeSubject(e, ttIndex, sIndex)
//                               }
//                             >
//                               <option value="">-Select Subject-</option>
//                               {subjectList?.map((subjectObj, index) => (
//                                 <option key={index} value={subjectObj.id}>
//                                   {subjectObj.name}
//                                 </option>
//                               ))}
//                             </Form.Select>
//                           </Form.Group>

//                           {slotData.timetable ? (
//                             slotData.timetable.contact_id &&
//                             !slotData.timetable.subject_id ? (
//                               <p className="error-timetable">Select Subject!</p>
//                             ) : null
//                           ) : null}

//                           {slotData.timetable ? (
//                             slotData.timetable.subject_id &&
//                             !slotData.timetable.contact_id ? (
//                               <p className="error-timetable">Select Teacher!</p>
//                             ) : null
//                           ) : null}
//                         </td>
//                       ))
//                     )}
//                   </tr>
//                 )}
//               </React.Fragment>
//             ))
//           : null}

//         <tr>
//           <td colSpan={7} style={{ textAlign: "right" }}>
//             <Button className="btn-md mx-2" onClick={onSave}>
//               Save
//             </Button>
//             <Button className="btn-md mx-2" onClick={() => changeView("VIEW")}>
//               Cancel
//             </Button>
//           </td>
//         </tr>
//       </tbody>
//     </Table>
//   );
// }

import { Table, Button, Form } from "react-bootstrap";
import schoolApi from "../../api/schoolApi";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { convertTo12HourFormat } from "../../utils/helper";

export default function EditTimeTable({
  timeTableSlots,
  sessionId,
  sectionId,
  classId,
  changeView,
  category,
}) {
  console.log("Edit Loaded Data: ", timeTableSlots);
  let periodIndex = 0;

  let [teacherList, setTeacherList] = useState([]);
  let [subjectList, setSubjectList] = useState([]);
  let [timeTable, setTimeTable] = useState([]);
  let [breakData, setBreakData] = useState([]);
  async function initTeacherList() {
    try {
      console.log("cateory==>", category);
      teacherList = await schoolApi.getTeacherRecords(category);
      console.log("teacherList", teacherList?.teacherData);
      setTeacherList(teacherList?.teacherData);
    } catch (error) {
      toast.error(error.message);
    }
  }
  async function initSubjectList() {
    try {
      subjectList = await schoolApi.fetchSubject();
      if (subjectList.success) {
        console.log("subjectList@!!@=>", subjectList);
        setSubjectList(subjectList?.result);
      }
    } catch (error) {
      toast.error(error.message);
    }
  }
  useEffect(() => {
    async function init() {
      console.log("ushgdhsgjj", timeTableSlots);
      if (timeTableSlots) {
        setTimeTable(timeTableSlots);
        timeTableSlots?.forEach((slot) => {
          console.log("slotywtey=>", slot?.time_slot);
        
          if (
            (slot?.time_slot?.type?.toLowerCase().includes("break") && slot?.time_slot?.type !== "Lunch") || 
            slot?.time_slot?.type === "Lunch"
          ) {
            setBreakData((prevData) => [
              ...(Array.isArray(prevData) ? prevData : []),
              {
                type: slot?.time_slot?.type,
                class_id: classId,
                section_id: sectionId,
                session_id: slot?.time_slot?.session_id,
                time_slot_id: slot?.time_slot?.id,
              },
            ]);
          }
        });
        
      }
      initTeacherList();
      initSubjectList();
    }
    init();
  }, []);

  const onChangeTeacher = async (e, ttIndex, sIndex) => {
    setTimeTable((prevTimetable) => {
      const updatedTimetable = [...prevTimetable];
      const timeTable = updatedTimetable[ttIndex];
      const data = updatedTimetable[ttIndex].data[sIndex];
      if (data.timetable) {
        console.log("data.timetable --> ", data.timetable);
        data.timetable.contact_id = e.target.value;
      } else {
        data.timetable = {
          id: null,
          contact_id: e.target.value,
          subject_id: data.timetable ? data.timetable.subject_id : "",
          time_slot_id: timeTable.time_slot.id,
          section_id: sectionId,
          class_id: classId,
          session_id: sessionId,
          day: data.day,
        };
      }
      return updatedTimetable;
    });
  };

  const onChangeSubject = async (e, ttIndex, sIndex) => {
    setTimeTable((prevTimetable) => {
      const updatedTimetable = [...prevTimetable];
      const timeTable = updatedTimetable[ttIndex];
      console.log("timeTable: ", timeTable);

      const data = updatedTimetable[ttIndex].data[sIndex];
      console.log("data: ", data);
      if (data.timetable) {
        console.log("data.timetable --> ", data.timetable);
        data.timetable.subject_id = e.target.value;
      } else {
        data.timetable = {
          id: null,
          contact_id: data.timetable ? data.timetable.contact_id : "",
          subject_id: e.target.value,
          time_slot_id: timeTable.time_slot.id,
          section_id: sectionId,
          class_id: classId,
          session_id: sessionId,
          day: data.day,
        };
      }
      return updatedTimetable;
    });
  };

  const onSave = async () => {
    try {
      let timeTableRecords = [];
      let isError = false;
      for (const tt of timeTable) {
        for (const data of tt.data) {
          if (data.timetable) {
            if (!data.timetable.subject_id || !data.timetable.contact_id) {
              isError = true;
              break;
            }
            timeTableRecords.push(data.timetable);
          }
        }
        if (isError) {
          break;
        }
      }
      if (isError) {
        toast.error("Required fields are missing, please select!", {
          position: toast.POSITION.TOP_RIGHT,
        });
        return;
      }
      console.log('breakData22=>',breakData)
      console.log("timeTableRecords@@@=>", timeTableRecords);
      timeTableRecords.push(breakData);
      let result = await schoolApi.upsertTimetable(timeTableRecords);
      console.log(result);
      if (result.success) {
        toast.success("Record udpated successfully!", {
          position: toast.POSITION.TOP_RIGHT,
        });
        changeView("VIEW");
      } else {
        let error = "Something went wrong!";
        if (result.error) {
          error = result.error;
        }
        toast.error(error, {
          position: toast.POSITION.TOP_RIGHT,
        });
        console.log(error);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  function TeacherOption({ teachRec, index, timeTableData, timeSlot }) {
    let displayTeacher = !(teachRec.schedule && teachRec.schedule.length > 0);
    if (!displayTeacher) {
      let bookedSlots = teachRec.schedule.filter(
        (record) =>
          record.timeslot_id === timeSlot.time_slot.id &&
          record.day === timeTableData.day
      );
      displayTeacher = bookedSlots.length === 0;
      if (
        !displayTeacher &&
        timeTableData.timetable &&
        timeTableData.timetable.id
      ) {
        bookedSlots = teachRec.schedule.filter(
          (record) => record.id === timeTableData.timetable.id
        );
        displayTeacher = bookedSlots.length > 0;
      }
    }
    return displayTeacher ? (
      <option key={index} value={teachRec.id}>
        {teachRec.teachername}
      </option>
    ) : (
      <></>
    );
  }
  return (
    <Table striped bordered hover>
      <thead>
        <tr>
          <th>Time Slot</th>
          <th>Monday</th>
          <th>Tuesday</th>
          <th>Wednesday</th>
          <th>Thursday</th>
          <th>Friday</th>
          <th>Saturday</th>
        </tr>
      </thead>

      <tbody>
        {timeTable && Object.keys(timeTable).length > 0
          ? timeTable.map((timeSlot, ttIndex) => (
              <React.Fragment key={ttIndex}>
                {console.log("timeSlot@@=>", timeSlot)}
                {timeSlot.time_slot.status === "active" && (
                  <tr style={{ textAlign: "center" }}>
                    <td style={{ paddingTop: "30px" }}>
                      {convertTo12HourFormat(timeSlot.time_slot.start_time)} -{" "}
                      {convertTo12HourFormat(timeSlot.time_slot.end_time)}
                      <br /> <br />
                      <p style={{ fontWeight: "bold" }}>
                        {["Lunch", "Break"].some((item) =>
                          timeSlot.time_slot.type
                            .toLowerCase()
                            .startsWith(item.toLowerCase())
                        )
                          ? ""
                          : `(Period-${++periodIndex})`}
                      </p>
                    </td>
                    {console.log(
                      "timeSlot.time_slot.type.toLowerCase()@@=>",
                      timeSlot.time_slot.type
                    )}
                    {["Lunch"].includes(timeSlot.time_slot.type) ||
                    timeSlot.time_slot.type.startsWith("Break") ? (
                      <td
                        colSpan={6}
                        style={{
                          textAlign: "center",
                          fontWeight: "bold",
                          paddingTop: "20px",
                        }}
                      >
                        {timeSlot.time_slot.type.toLowerCase() === "lunch"
                          ? "Lunch Time"
                          : timeSlot.time_slot.type
                              .toLowerCase()
                              .startsWith("break")
                          ? "Break Time"
                          : ""}
                      </td>
                    ) : (
                      timeSlot.data.map((slotData, sIndex) => (
                        <td key={sIndex}>
                          <Form.Group className="mx-0">
                            <Form.Select
                              name="teacher"
                              value={
                                slotData.timetable
                                  ? slotData.timetable.contact_id
                                  : ""
                              }
                              onChange={(e) =>
                                onChangeTeacher(e, ttIndex, sIndex)
                              }
                            >
                              <option value="">-Select Teacher-</option>
                              {teacherList?.map((teachRec, index) => (
                                <TeacherOption
                                  teachRec={teachRec}
                                  index={index}
                                  timeTableData={slotData}
                                  timeSlot={timeSlot}
                                />
                              ))}
                            </Form.Select>
                          </Form.Group>

                          <Form.Group className="mx-0 mt-3">
                            <Form.Select
                              name="subject"
                              value={
                                slotData.timetable
                                  ? slotData.timetable.subject_id
                                  : ""
                              }
                              onChange={(e) =>
                                onChangeSubject(e, ttIndex, sIndex)
                              }
                            >
                              <option value="">-Select Subject-</option>
                              {subjectList?.map((subjectObj, index) => (
                                <option key={index} value={subjectObj.id}>
                                  {subjectObj.name}
                                </option>
                              ))}
                            </Form.Select>
                          </Form.Group>

                          {slotData.timetable ? (
                            slotData.timetable.contact_id &&
                            !slotData.timetable.subject_id ? (
                              <p className="error-timetable">Select Subject!</p>
                            ) : null
                          ) : null}

                          {slotData.timetable ? (
                            slotData.timetable.subject_id &&
                            !slotData.timetable.contact_id ? (
                              <p className="error-timetable">Select Teacher!</p>
                            ) : null
                          ) : null}
                        </td>
                      ))
                    )}
                  </tr>
                )}
              </React.Fragment>
            ))
          : null}

        <tr>
          <td colSpan={7} style={{ textAlign: "right" }}>
            <Button className="btn-md mx-2" onClick={onSave}>
              Save
            </Button>
            <Button className="btn-md mx-2" onClick={() => changeView("VIEW")}>
              Cancel
            </Button>
          </td>
        </tr>
      </tbody>
    </Table>
  );
}